import { internalLinkClicked } from "../analytics"

interface InternalLinkProps {
    href: string
    children: string
    analyticsParentHeading: string,
    siteSection?: 'mfa' | 'account management'
}
export const InternalLink = (props: InternalLinkProps) => {
    const onClick = () => {
        internalLinkClicked({
            linkText: props.children,
            linkUrl: props.href,
            parentComponentHeading: props.analyticsParentHeading,
            siteSection: props.siteSection
        });
    }
    return <a onClick={onClick} href={props.href}>{props.children}</a>
}